/*
 * ============================================================================
 *  LEGACY (payload_version = 0) BRAND RENDERER — DELETE with the rest of v0.
 * ============================================================================
 *
 * Why brands need their own v0 renderer instead of reusing legacyPayloadAdapter:
 * legacy birdview rows stored the SUBMITTED BODY in `payload` (not a "before" snapshot),
 * and `updated_payload` was null for adds. Running the generic before/after diff over that
 * renders it BACKWARDS ("value → —") for an add. So v0 brands are a flat dump of the
 * submitted values — which is exactly what this always was.
 *
 * v1 rows do not come here: payload is the previous DB record and request_payload is the
 * submitted body, so they go through the shared dispatcher + ComparisonTable.
 *
 * To retire: delete this file and the `!isKeyedPayload(data)` branch in BrandChecker.
 */
import React from "react";
import { BRAND_HIDDEN_FIELDS, brandFieldLabel, formatBrandValue } from "./brandFormat";

const LegacyBrandDetails = ({ payload }) => (
  <>
    {Object.entries(payload).map(([key, value]) => {
      if (BRAND_HIDDEN_FIELDS.includes(key)) return null;

      const isEmpty =
        value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0);
      const formatted = formatBrandValue(key, value);
      const displayValue = isEmpty ? "-" : formatted !== undefined ? formatted : String(value);

      return (
        <p key={key} className="mb-1">
          <strong>{brandFieldLabel(key)}:</strong> {displayValue}
        </p>
      );
    })}
  </>
);

export default LegacyBrandDetails;
